import { Link, Text } from '@chakra-ui/react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const ResetPasswordLink: FC = () => {
  const { t } = useTranslation();

  return (
    <Text
      size="poppins16"
      variant="primary-black-text"
      textAlign="center"
      lineHeight="22px"
      mb="24px"
    >
      {t('Forgot your ')}
      <Link
        href='/auth/reset-password'
        rel='noreferrer'
        variant="resetPassword"
        _hover={{ textDecoration: 'none' }}
      >
        {t('password')}
      </Link>{' '}
      {t('?')}
    </Text>
  );
};
